<ng-template #content>
<div>
    <ng-container *ngIf="useOtp">
      <ng-container *ngIf="!useNewDesignOtpWhatsappUssdDeviceRegistration else otpContent">
        <app-mobile-device-registration (emitSubmit)="activateDeviceV2($event)"
            [expiryTime]="deviceRegistrationParameters?.expiryTime"
            [submitting]="submitting"
            [ussdCode]="deviceRegistrationParameters?.ussdCode">
        </app-mobile-device-registration>
      </ng-container>
    </ng-container>
    <div class="flex flex-col" *ngIf="!useOtp">
        <div class="text-[24px] py-[24px] px-[20px] font-bold">Face Verification</div>
        <div class="p-5 bg-white rounded-[16px]">
            <app-liveliness class="grow flex flex-col"
				[identityProvider]="identityProvider"
                [reference]="livelinessCheckReference"
                (nextStepMoved)="livelinessStepCompleted($event)"
                [isSubmitting]="submitting"
                [isMobileView]="true"
                [noBottomPadding]="true"
                [type]="feature"
                [is2FAEnabled]="is2FAEnabled"
                [username]="deviceRegistrationParameters?.username">
            </app-liveliness>
        </div>
    </div>
</div>
</ng-template>
<ng-container *ngIf="loading, else content">
  <app-loading [loadingText]="'Please wait...'"></app-loading>
</ng-container>

<ng-template #otpContent>
    <app-mobile-kamona-otp-widget
    (emitBack)="goBack()"
    [ussd]="deviceRegistrationParameters?.ussdCode"
    (emitReload)="reloadOtp($event)"
    [currentOtpMode]="currentOTPMode || currentOtpModes?.SMS_MODE"
    [minHeight]="289"
    btnText="Next"
    [canUseWhatsappOTPResend]="useResendOtpViaWhatsapp"
    [canUseSmsOTPResend]="useResendOtpViaSms"
    [canUseNewUssd]="canUseNewUssd"
    [hasResendButtonCountdown]="false"
    [showBothCountDown]="showBothCountDown"
    [submitting]="submitting"
    (emitSubmit)="activateDeviceV3($event)"
    [description]="deviceRegistrationParameters?.message
    || 'We’ve just sent you a 6 digit code. Check your messages and enter it here.'"
    title="Verify Your Phone Number">
  </app-mobile-kamona-otp-widget>
</ng-template>
